<template>
  <div class="ios-glass-page">
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
    </div>

    <div class="section-label">当前控制设备</div>
    <div class="glass-card current-device-card" @click="openDevicePopup">
      <div class="device-icon-box" :class="{ 'online': isOnline(deviceData) }">
        <van-icon name="desktop-o" size="24" color="#fff" />
        <div class="pulse-ring" v-if="isOnline(deviceData)"></div>
      </div>
      <div class="device-content">
        <div class="device-name">{{ deviceData.remark || '请点击选择设备' }}</div>
        <div class="device-status">
          <span :class="isOnline(deviceData) ? 'text-green' : 'text-gray'">
            {{ isOnline(deviceData) ? '设备在线' : '设备离线' }}
          </span>
          <span class="divider">|</span>
          <span>{{ deviceData.ip || '--' }}</span>
        </div>
      </div>
      <div class="arrow-btn">
        <span>切换</span>
        <van-icon name="arrow" />
      </div>
    </div>

    <div class="glass-card info-grid-card">
      <div class="project-control-row">
        <div class="label-group">
          <div class="label">当前运行项目</div>
          <div class="value highlight">{{ getProjectName(deviceData.projectCode) }}</div>
        </div>
        <van-button 
          type="info" 
          size="small" 
          round 
          color="#007AFF"
          @click="openProjectPopup"
        >
          切换项目
        </van-button>
      </div>
      <div class="divider-line"></div>
    </div>

    <!-- 跳跳乐园专属配置卡片 (方案 B：独立卡片，仅对跳跳乐园开放) -->
    <div v-if="isTiaotiao">
      <div class="section-label" style="margin-top: 18px; display: flex; justify-content: space-between; align-items: center;">
        <span>跳跳乐园项目配置</span>
        <span style="font-size: 11px; color: #007AFF; font-weight: normal;">仅跳跳设备生效</span>
      </div>
      <div class="glass-card info-grid-card" style="margin-bottom: 16px;">
        <!-- 1. 项目配置 (大项目) -->
        <div class="project-control-row" style="background: rgba(255,255,255,0.35);">
          <div class="label-group">
            <div class="label" style="display: flex; align-items: center; gap: 4px;">
              <span style="font-size: 13px; font-weight: 600; color: #1c1c1e;">项目配置</span>
              <span style="font-size: 10px; padding: 1px 5px; background: #e8f0fe; color: #1a73e8; border-radius: 4px;">大项目</span>
            </div>
            <div style="font-size: 11px; color: #8e8e93; margin-top: 4px;">
              已开放 {{ selectedProjectCodes.length }} 个项目
            </div>
          </div>
          <van-button 
            type="info" 
            size="small" 
            plain 
            round 
            color="#007AFF"
            @click="openProjectConfigPopup"
          >
            去配置
          </van-button>
        </div>

        <div class="divider-line"></div>

        <!-- 2. 活力15项目配置 (动作库) -->
        <div class="project-control-row" style="background: rgba(255,255,255,0.35);">
          <div class="label-group">
            <div class="label" style="display: flex; align-items: center; gap: 4px;">
              <span style="font-size: 13px; font-weight: 600; color: #1c1c1e;">活力15项目配置</span>
              <span style="font-size: 10px; padding: 1px 5px; background: #e6f4ea; color: #137333; border-radius: 4px;">动作库</span>
            </div>
            <div style="font-size: 11px; color: #8e8e93; margin-top: 4px;">
              已开放 {{ selectedTiaotiaoCodes.length }} 个训练动作
            </div>
          </div>
          <van-button 
            type="primary" 
            size="small" 
            plain 
            round 
            color="#34C759"
            @click="openTiaotiaoConfigPopup"
          >
            去配置
          </van-button>
        </div>
      </div>
    </div>

    <div class="section-label" style="margin-top: 24px;">定时任务设置</div>
    <div class="glass-card timer-card">
      
      <div class="week-selector">
        <div 
          v-for="item in weekList" 
          :key="item.id"
          class="week-item"
          :class="{ 'active': submitData.week === item.id }"
          @click="handleWeekChange(item.id)"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="timer-list">
        <div v-for="(item, idx) in timerSettings.timeRanges" :key="idx" class="timer-item-glass">
          <div class="timer-header">
            <span class="index-badge">时间段 {{ idx + 1 }}</span>
            <van-icon 
              v-if="timerSettings.timeRanges.length > 1" 
              name="delete-o" 
              color="#FF3B30" 
              size="18"
              @click="removeTimeRange(idx)"
            />
          </div>
          
          <div class="timer-inputs">
            <div class="input-group">
              <span class="sub-label">开始</span>
              <el-time-picker
                v-model="item.startTime"
                placeholder="00:00"
                size="mini"
                format="HH:mm"
                value-format="HH:mm"
                :clearable="false"
                class="glass-input"
              />
            </div>
            <div class="separator">to</div>
            <div class="input-group">
              <span class="sub-label">结束</span>
              <el-time-picker
                v-model="item.endTime"
                placeholder="00:00"
                size="mini"
                format="HH:mm"
                value-format="HH:mm"
                :clearable="false"
                class="glass-input"
              />
            </div>
          </div>

          <div class="timer-project-select">
            <span class="sub-label">执行项目</span>
            <el-select
              v-model="item.projectCode"
              placeholder="选择该时段项目"
              size="mini"
              style="width: 100%;"
              class="glass-select"
            >
              <el-option-group
                v-for="group in groupedProjectList"
                :key="group.category"
                :label="group.category"
              >
                <el-option
                  v-for="p in group.projects"
                  :key="p.projectCode"
                  :label="p.projectName || p.name || p.projectCode"
                  :value="p.projectCode"
                />
              </el-option-group>
            </el-select>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <div class="add-btn" @click="addTimeRange">
          <van-icon name="plus" /> 添加时间段
        </div>
        <div class="timer-btn-actions">
          <van-button 
            block 
            round 
            plain
            type="info"
            color="#007AFF"
            class="sync-btn"
            @click="openSyncPopup"
          >
            <van-icon name="share-o" style="margin-right: 4px;" /> 同步应用到其他天...
          </van-button>
          <van-button 
            block 
            round 
            color="linear-gradient(to right, #007AFF, #5856D6)" 
            @click="confirmSetTimer"
          >
            保存当前定时配置 ({{ currentWeekName }})
          </van-button>
        </div>
      </div>
    </div>

    <van-popup v-model="showDevicePopup" position="bottom" round class="popup-box" :style="{ height: '70%' }">
      <div class="popup-header">
        <div class="title">切换设备</div>
        <van-icon name="cross" size="20" color="#999" @click="showDevicePopup = false"/>
      </div>
      <van-search v-model="searchText" placeholder="搜索设备" shape="round" />
      <div class="popup-content">
        <div class="device-grid">
           <div 
              v-for="item in filteredDeviceList" 
              :key="item.code"
              class="device-item"
              :class="{ 'active': deviceData.code === item.code, 'offline': !isOnline(item) }"
              @click="handleSelectDevice(item)"
            >
              <div class="status-dot"></div>
              <div class="name">{{ item.remark || '未知' }}</div>
              <div class="ip">{{ item.ip || 'No IP' }}</div>
           </div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showProjectPopup" position="bottom" round class="popup-box" :style="{ height: '80%' }">
      <div class="popup-header">
        <div class="title">选择要切换的项目</div>
        <van-icon name="cross" size="20" color="#999" @click="showProjectPopup = false"/>
      </div>
      <div class="popup-content" style="padding: 0 0 20px 0;">
        <div v-for="group in groupedProjectList" :key="group.category" class="project-group">
          <div class="group-title">{{ group.category }}</div>
          <div class="project-grid">
            <div 
              v-for="item in group.projects" 
              :key="item.projectCode"
              class="project-item"
              :class="{ 'selected': deviceData.projectCode === item.projectCode }"
              @click="confirmChangeProject(item)"
            >
              <div class="icon-box" :style="{ background: getProjectColor(item.projectCode) }">
                <span class="initial">{{ (item.projectName || item.name || item.projectCode || '?').charAt(0) }}</span>
              </div>
              <div class="name">{{ item.projectName || item.name || item.projectCode }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 弹窗 1：跳跳乐园大项目多选配置弹窗 -->
    <van-popup v-model="showProjectConfigPopup" position="bottom" round class="popup-box" :style="{ height: '78%' }">
      <div class="popup-header">
        <div>
          <div class="title">跳跳乐园项目配置</div>
          <div style="font-size: 11px; color: #8e8e93; margin-top: 2px;">勾选要在跳跳乐园终端开放的大项目</div>
        </div>
        <van-icon name="cross" size="20" color="#999" @click="showProjectConfigPopup = false"/>
      </div>
      <div class="popup-content" style="padding: 10px 16px 80px 16px;">
        <div class="config-project-grid">
          <div 
            v-for="item in allProjectCodeList" 
            :key="item.projectCode || item.code"
            class="config-select-item"
            :class="{ 'active': tempProjectCodes.includes(item.projectCode || item.code) }"
            @click="toggleProjectSelection(item.projectCode || item.code)"
          >
            <div class="item-name">{{ item.projectName || item.name || item.projectCode }}</div>
            <van-icon 
              :name="tempProjectCodes.includes(item.projectCode || item.code) ? 'checked' : 'circle'" 
              :color="tempProjectCodes.includes(item.projectCode || item.code) ? '#007AFF' : '#c8c9cc'" 
              size="18"
            />
          </div>
        </div>
      </div>
      <div class="popup-bottom-bar">
        <van-button size="small" plain round @click="toggleAllProjects">
          {{ tempProjectCodes.length === allProjectCodeList.length ? '全部取消' : '全选项目' }}
        </van-button>
        <van-button 
          type="info" 
          size="small" 
          round 
          color="#007AFF"
          :loading="savingProjectConfig"
          @click="saveProjectConfig"
          style="flex: 1; margin-left: 12px;"
        >
          保存配置 (已选 {{ tempProjectCodes.length }} 项)
        </van-button>
      </div>
    </van-popup>

    <!-- 弹窗 2：活力15内部训练项多选配置弹窗 -->
    <van-popup v-model="showTiaotiaoConfigPopup" position="bottom" round class="popup-box" :style="{ height: '78%' }">
      <div class="popup-header">
        <div>
          <div class="title">活力15项目配置</div>
          <div style="font-size: 11px; color: #8e8e93; margin-top: 2px;">勾选活力15模式下开放轮播的训练动作</div>
        </div>
        <van-icon name="cross" size="20" color="#999" @click="showTiaotiaoConfigPopup = false"/>
      </div>
      <div class="popup-content" style="padding: 10px 16px 80px 16px;">
        <div class="config-project-grid tiaotiao-grid">
          <div 
            v-for="item in allTiaotiaoCodeList" 
            :key="item.projectCode || item.code"
            class="config-select-item"
            :class="{ 'active-green': tempTiaotiaoCodes.includes(item.projectCode || item.code) }"
            @click="toggleTiaotiaoSelection(item.projectCode || item.code)"
          >
            <div class="item-name">{{ item.projectName || item.name || item.projectCode }}</div>
            <van-icon 
              :name="tempTiaotiaoCodes.includes(item.projectCode || item.code) ? 'checked' : 'circle'" 
              :color="tempTiaotiaoCodes.includes(item.projectCode || item.code) ? '#34C759' : '#c8c9cc'" 
              size="18"
            />
          </div>
        </div>
      </div>
      <div class="popup-bottom-bar">
        <van-button size="small" plain round @click="toggleAllTiaotiao">
          {{ tempTiaotiaoCodes.length === allTiaotiaoCodeList.length ? '全部取消' : '全选动作' }}
        </van-button>
        <van-button 
          type="primary" 
          size="small" 
          round 
          color="#34C759"
          :loading="savingTiaotiaoConfig"
          @click="saveTiaotiaoConfig"
          style="flex: 1; margin-left: 12px;"
        >
          保存配置 (已选 {{ tempTiaotiaoCodes.length }} 项)
        </van-button>
      </div>
    </van-popup>

    <!-- 弹窗 3：定时任务同步应用至其他天弹窗 (批量设置) -->
    <van-popup v-model="showSyncPopup" position="bottom" round class="popup-box" :style="{ height: '78%' }">
      <div class="popup-header">
        <div>
          <div class="title">同步应用至其他天</div>
          <div style="font-size: 11px; color: #8e8e93; margin-top: 2px;">
            将【{{ currentWeekName }}】已配置的 {{ validTimeRangeCount }} 个时间段批量同步覆盖
          </div>
        </div>
        <van-icon name="cross" size="20" color="#999" @click="showSyncPopup = false"/>
      </div>

      <div class="popup-content" style="padding: 10px 16px 80px 16px;">
        <!-- 快捷批量选择预设胶囊栏 -->
        <div class="sync-quick-bar">
          <span class="sync-quick-label">快捷选择：</span>
          <div class="sync-quick-tags">
            <span class="sync-tag" @click="selectSyncPreset('workday')">⚡ 工作日 (周一至周五)</span>
            <span class="sync-tag" @click="selectSyncPreset('all')">全选 (整周)</span>
            <span class="sync-tag clear-tag" @click="selectSyncPreset('clear')">清空</span>
          </div>
        </div>

        <!-- 星期网格列表 (复用已有的 config-project-grid 样式) -->
        <div class="config-project-grid">
          <div 
            v-for="item in availableSyncWeeks" 
            :key="item.id"
            class="config-select-item"
            :class="{ 'active': selectedSyncWeeks.includes(item.id) }"
            @click="toggleSyncWeek(item.id)"
          >
            <div>
              <div class="item-name">{{ item.name }}</div>
              <div style="font-size: 10px; color: #8e8e93; margin-top: 2px;">
                {{ item.id === submitData.week ? '当前编辑天' : '将覆盖该天' }}
              </div>
            </div>
            <van-icon 
              :name="selectedSyncWeeks.includes(item.id) ? 'checked' : 'circle'" 
              :color="selectedSyncWeeks.includes(item.id) ? '#007AFF' : '#c8c9cc'" 
              size="18"
            />
          </div>
        </div>

        <!-- 友好提示 -->
        <div class="sync-tip-box">
          <van-icon name="info-o" color="#007AFF" size="14" style="margin-right: 6px; margin-top: 1px; flex-shrink: 0;" />
          <span>确认同步后，所选日期的原有时间段设置将被当前【{{ currentWeekName }}】的时间段与项目统一覆写并自动保存。</span>
        </div>
      </div>

      <div class="popup-bottom-bar">
        <van-button size="small" plain round @click="toggleAllSyncWeeks">
          {{ selectedSyncWeeks.length === availableSyncWeeks.length ? '全部取消' : '全选日期' }}
        </van-button>
        <van-button 
          type="info" 
          size="small" 
          round 
          color="linear-gradient(to right, #007AFF, #5856D6)"
          :loading="savingSync"
          @click="confirmSyncToOtherWeeks"
          style="flex: 1; margin-left: 12px;"
        >
          确认同步并保存 (已选 {{ selectedSyncWeeks.length }} 天)
        </van-button>
      </div>
    </van-popup>

  </div>
</template>

<script>
import { Dialog } from 'vant';
import { 
  selectSchoolDeviceList,
  selectSchoolDeviceStatus,
  chooseDeviceProject,
  setWeekDeviceInfo,
  selectWeekDeviceInfo,
  selectSchoolDeviceProjectCodeList,
  selectAllDeviceProjectCodeList,
  updateDeviceProjectCode,
  selectAllDeviceTiaotiaoProjectCodeList,
  selectSchoolDeviceTiaotiaoProjectCodeList,
  updateDeviceTiaotiaoProjectCode
} from "@/api/teacher/deviceControl.js";
import moment from 'moment';

export default {
  name: 'DeviceTimerControl',
  data() {
    return {
      teacherTitleInfo: {},
      
      showDevicePopup: false,
      showProjectPopup: false,
      searchText: '',

      deviceList: [],
      // 初始化空，由加载设备后动态合并
      projectList: [],
      
      weekList: [
        { id: "1", name: '周一' },
        { id: "2", name: '周二' },
        { id: "3", name: '周三' },
        { id: "4", name: '周四' },
        { id: "5", name: '周五' },
        { id: "6", name: '周六' },
        { id: "7", name: '周日' },
      ],

      deviceData: {}, 
      submitData: {
        week: "1" 
      },
      timerSettings: {
        timeRanges: [{ startTime: '', endTime: '', projectCode: '' }]
      },
      showProjectConfigPopup: false,
      showTiaotiaoConfigPopup: false,
      allProjectCodeList: [],
      selectedProjectCodes: [],
      tempProjectCodes: [],
      allTiaotiaoCodeList: [],
      selectedTiaotiaoCodes: [],
      tempTiaotiaoCodes: [],
      savingProjectConfig: false,
      savingTiaotiaoConfig: false,
      showSyncPopup: false,
      selectedSyncWeeks: [],
      savingSync: false,
    };
  },
  computed: {
    currentWeekName() {
      const current = (this.weekList || []).find(w => String(w.id) === String(this.submitData.week));
      return current ? current.name : '周' + this.submitData.week;
    },
    availableSyncWeeks() {
      return (this.weekList || []).filter(w => String(w.id) !== String(this.submitData.week));
    },
    validTimeRangeCount() {
      if (!this.timerSettings || !this.timerSettings.timeRanges) return 0;
      return this.timerSettings.timeRanges.filter(t => t.startTime && t.endTime && t.projectCode).length;
    },
    isTiaotiao() {
      if (!this.deviceData) return false;
      const rawType = (this.deviceData.rawDeviceType || "").trim().toLowerCase();
      const pCode = (this.deviceData.projectCode || "").trim().toLowerCase();
      const dType = (this.deviceData.deviceType || "").trim().toLowerCase();
      const chooseCode = (this.deviceData.chooseProjectCode || "").trim().toLowerCase();
      return rawType === 'tiaotiao' || dType === 'tiaotiao' || pCode === 'tiaotiao' || chooseCode === 'tiaotiao';
    },
    filteredDeviceList() {
      let list = this.deviceList;
      if (this.searchText) {
        const key = this.searchText.toLowerCase();
        list = list.filter(item => (item.remark + item.ip).toLowerCase().includes(key));
      }
      return list.sort((a,b) => {
        const aOn = this.isOnline(a) ? 1 : 0;
        const bOn = this.isOnline(b) ? 1 : 0;
        return bOn - aOn;
      });
    },
    // 将平铺的项目列表转换为带分类的分组结构
    groupedProjectList() {
      const groups = {};
      this.projectList.forEach(p => {
        const cat = p.category || '基础项目';
        if (!groups[cat]) {
          groups[cat] = [];
        }
        groups[cat].push(p);
      });
      // 转化为数组便于 v-for 渲染
      return Object.keys(groups).map(key => ({
        category: key,
        projects: groups[key]
      }));
    }
  },
  mounted() {
    this.teacherTitleInfo = JSON.parse(sessionStorage.getItem('teacherTitleInfo') || '{}');
    this.getList();
  },
  methods: {
    isOnline(deviceOrTime) {
      if (!deviceOrTime) return false;
      if (typeof deviceOrTime === 'object' && !(deviceOrTime instanceof Date)) {
        // 后端已按"心跳时间窗优先 + MQTT onlineStatus 兜底"统一判定，对象入参直接采用后端结果
        const status = deviceOrTime.onlineStatus;
        if (status !== undefined && status !== null && status !== '') {
          return status === '1' || status === 1;
        }
        const time = deviceOrTime.lastOnlineTime;
        if (time && moment(time).isValid()) {
          const diffMinutes = moment().diff(moment(time), 'minutes');
          return diffMinutes >= -5 && diffMinutes < 10;
        }
        return false;
      }
      if (!moment(deviceOrTime).isValid()) return false;
      const diffMinutes = moment().diff(moment(deviceOrTime), 'minutes');
      return diffMinutes >= -5 && diffMinutes < 10;
    },
    formatLastTime(time) {
      if (!time) return '--';
      return moment(time).isSame(moment(), 'day') ? moment(time).format('HH:mm') : moment(time).format('MM-DD');
    },
    getProjectName(code) {
      const p = this.projectList.find(i => i.projectCode === code);
      return p ? (p.projectName || p.name || p.projectCode) : (code || '未选择');
    },
    getProjectColor(code) {
      const colors = ['#FF9500', '#34C759', '#007AFF', '#5856D6', '#FF2D55', '#AF52DE'];
      let hash = 0;
      if(code) {
        for(let i=0; i<code.length; i++) hash += code.charCodeAt(i);
      }
      return colors[hash % colors.length];
    },

    getList() {
      selectSchoolDeviceList({
        userId: this.teacherTitleInfo.teacherId,
        userName: this.teacherTitleInfo.teacherName,
        schoolCode: this.teacherTitleInfo.schoolCode,
        projectCode: 'tiaotiao',
      }).then(res => {
        if(res.data && res.data.body) {
          this.deviceList = res.data.body;
          const first = this.filteredDeviceList[0];
          if(first) this.handleSelectDevice(first, false);
        }
      });
    },

    async handleSelectDevice(item, closePopup = true) {
      if(closePopup) this.showDevicePopup = false;
      this.deviceData = item;
      
      if(closePopup) this.$toast.loading({ forbidClick: true });

      try {
        const res = await selectSchoolDeviceStatus({ deviceId: item.code, schoolCode: item.schoolCode });
        const rawDevType = res.data?.body?.projectCode || item.projectCode || item.deviceType || '';
        this.deviceData = { ...item, ...res.data.body, rawDeviceType: rawDevType };
        this.$set(this.deviceData, 'projectCode', this.deviceData.chooseProjectCode || this.deviceData.projectCode);
        
        await this.selectSchoolDeviceProjectCodeList();
        await this.weekSelectionChange(); 
        
        if (this.isTiaotiao) {
          await this.loadDeviceTiaotiaoConfig();
        }
        
        if(closePopup) this.$toast.clear();
      } catch(e) {
        if(closePopup) this.$toast.clear();
      }
    },
    openDevicePopup() {
      this.showDevicePopup = true;
      this.searchText = '';
    },

    async selectSchoolDeviceProjectCodeList() {
      const res = await selectSchoolDeviceProjectCodeList({
        deviceId: this.deviceData.code,
        schoolCode: this.teacherTitleInfo.schoolCode,
        checkType: '2'
      });
      
      let baseList = [];
      if(res.data && res.data.body && res.data.body.length > 0) {
        // 如果后台有数据，为其打上默认的基础分类标签
        baseList = res.data.body
          .filter(item => item && (item.projectCode || item.code))
          .map(item => {
            const pCode = String(item.projectCode || item.code || '').trim();
            const pName = item.projectName || item.name || pCode || '未命名项目';
            return {
              ...item,
              projectCode: pCode,
              projectName: pName,
              category: item.category || '基础项目'
            };
          });
        this.selectedProjectCodes = baseList
          .map(item => item.projectCode)
          .filter(code => code && String(code).trim().toLowerCase() !== 'home');
      } else {
        // 如果后台无返回，设置基础托底项目
        baseList = [
          { projectCode: "tiaotiao", projectName: '活力15' },
          { projectCode: "RopeSkippingPro", projectName: '跳绳' },
          { projectCode: "Jump", projectName: '立定跳远' },
          { projectCode: "LanQiu", projectName: '篮球拍球' },
          { projectCode: "PaiQiu", projectName: '排球颠球' },
          { projectCode: "Home", projectName: '画廊（选择项目）' }
        ].map(item => ({ ...item, category: '基础项目' }));
      }

      // ==========================================
      // 根据 schCode 追加带有分类标签的静态项目数据
      // ==========================================
      let staticList = [];
      if (this.teacherTitleInfo.schoolCode === 'fhyjytcs') {
        
        const funProjects = [
          { projectCode: "FunARHunt", projectName: 'AR寻宝跑' },
          { projectCode: "FunReaction", projectName: '反应力特训' },
          { projectCode: "FunDance", projectName: 'AI体感舞蹈' },
          { projectCode: "FunSmartRope", projectName: '智能跳绳挑战' },
          { projectCode: "FunShadowBox", projectName: '趣味拳击' },
          { projectCode: "FunPuzzleRun", projectName: '答题跑酷' },
          { projectCode: "FunBalance", projectName: '平衡挑战' },
          { projectCode: "FunAgility", projectName: '敏捷梯训练' },
          { projectCode: "FunVRRide", projectName: 'VR骑行' },
          { projectCode: "FunMemoryMove", projectName: '记忆动作操' }
        ].map(item => ({ ...item, category: '10+ 趣味锻炼 (AI&AR)' }));

        const aiProjects = [
          { projectCode: "AIBaduanjin", projectName: 'AI八段锦' },
          { projectCode: "AIClassBreak", projectName: 'AI课间操' },
          { projectCode: "AIEyeExercise", projectName: 'AI眼保健操' },
          { projectCode: "AIYoga", projectName: 'AI瑜伽' },
          { projectCode: "AITaichi", projectName: 'AI太极拳' },
          { projectCode: "AIAerobics", projectName: 'AI健身操' },
          { projectCode: "AIPilates", projectName: 'AI普拉提' },
          { projectCode: "AIWushu", projectName: 'AI武术基本功' },
          { projectCode: "AIStretch", projectName: 'AI拉伸放松' },
          { projectCode: "AIMeditation", projectName: 'AI冥想放松' }
        ].map(item => ({ ...item, category: '10+ AI跟我练' }));

        const ballProjects = [
          { projectCode: "BallFootballDribble", projectName: '足球盘带' },
          { projectCode: "BallFootballShoot", projectName: '足球射门' },
          { projectCode: "BallBasketballDribble", projectName: '篮球运球' },
          { projectCode: "BallBasketballShoot", projectName: '篮球投篮' },
          { projectCode: "BallVolleyballPass", projectName: '排球传球' },
          { projectCode: "BallVolleyballServe", projectName: '排球发球' },
          { projectCode: "BallTableTennis", projectName: '乒乓球颠球' },
          { projectCode: "BallBadminton", projectName: '羽毛球发球' }
        ].map(item => ({ ...item, category: '8+ 球类运动' }));

        staticList = [...funProjects, ...aiProjects, ...ballProjects];
      }

      // 组合数据流
      this.projectList = [...baseList, ...staticList];
    },
    
    openProjectPopup() {
      if(!this.deviceData.code) return this.$toast('请先选择设备');
      this.showProjectPopup = true;
    },
    confirmChangeProject(item) {
      this.showProjectPopup = false;
      Dialog.confirm({
        title: '切换项目',
        message: `确定将设备切换为【${item.projectName || item.name || item.projectCode || '所选项目'}】吗？\n切换后设备将于20s后响应。`,
        confirmButtonColor: '#007AFF'
      }).then(() => {
        this.deviceData.projectCode = item.projectCode;
        chooseDeviceProject({
          schoolCode: this.teacherTitleInfo.schoolCode,
          projectCode: item.projectCode,
          deviceId: this.deviceData.code,
        }).then(() => {
          this.$toast.success('指令已下发');
        });
      }).catch(() => {});
    },

    handleWeekChange(weekId) {
      this.submitData.week = weekId;
      this.weekSelectionChange();
    },
    async weekSelectionChange() {
      if (!this.deviceData.code || !this.submitData.week) return;
      
      const res = await selectWeekDeviceInfo({
        schoolCode: this.teacherTitleInfo.schoolCode,
        deviceId: this.deviceData.code,
        week: this.submitData.week,
      });
      
      let list = res.data.body || [];
      list = list.filter(item => item.week == this.submitData.week);
      
      if (list.length === 0) {
        this.timerSettings.timeRanges = [{ startTime: '', endTime: '', projectCode: '' }];
      } else {
        this.timerSettings.timeRanges = list;
      }
    },
    addTimeRange() {
      this.timerSettings.timeRanges.push({ startTime: '', endTime: '', projectCode: '' });
    },
    removeTimeRange(idx) {
      this.timerSettings.timeRanges.splice(idx, 1);
    },
    confirmSetTimer() {
      if (!this.deviceData.code) return this.$toast('请先选择设备');
      
      const valid = this.timerSettings.timeRanges.some(t => t.startTime && t.endTime && t.projectCode);
      if (!valid) return this.$toast('请完善时间段和项目设置');

      Dialog.confirm({
        title: '保存设置',
        message: `确定保存 [${this.deviceData.remark}] 周${this.submitData.week} 的定时任务吗？`,
        confirmButtonColor: '#007AFF'
      }).then(() => {
        let weekList = this.timerSettings.timeRanges.map(item => ({
          projectCode: item.projectCode,
          week: this.submitData.week,
          startTime: item.startTime,
          endTime: item.endTime,
        }));
        
        setWeekDeviceInfo({
          deviceId: this.deviceData.code,
          schoolCode: this.teacherTitleInfo.schoolCode,
          weekTimeList: weekList,
        }).then(() => {
          this.$notify({ type: "success", message: '设置保存成功' });
        });
      }).catch(() => {});
    },

    // ==========================================
    // 跳跳乐园专属配置逻辑 (大项目配置 + 活力15配置)
    // ==========================================
    async loadDeviceTiaotiaoConfig() {
      if (!this.deviceData || !this.deviceData.code) return;
      const devCode = this.deviceData.code;
      const schCode = this.teacherTitleInfo.schoolCode;

      try {
        // 1. 获取全量大项目列表与已配置大项目列表（彻底排除非业务项目 Home）
        const [allProRes, selectedProRes] = await Promise.all([
          selectAllDeviceProjectCodeList({ deviceId: devCode, schoolCode: schCode }).catch(() => ({ data: { body: [] } })),
          selectSchoolDeviceProjectCodeList({ deviceId: devCode, schoolCode: schCode, checkType: '0' }).catch(() => ({ data: { body: [] } }))
        ]);
        this.allProjectCodeList = (allProRes.data?.body || []).filter(item => {
          const code = (item?.projectCode || item?.code || "").trim();
          return code && code.toLowerCase() !== 'home';
        }).map(item => {
          const code = (item?.projectCode || item?.code || "").trim();
          return {
            ...item,
            projectCode: code,
            projectName: item.projectName || item.name || code || '未命名项目'
          };
        });
        const selectedPros = selectedProRes.data?.body || [];
        this.selectedProjectCodes = selectedPros
          .map(i => i.projectCode)
          .filter(code => code && String(code).trim().toLowerCase() !== 'home');

        // 2. 获取全量活力15动作列表与已配置活力15列表
        const [allTiaoRes, selectedTiaoRes] = await Promise.all([
          selectAllDeviceTiaotiaoProjectCodeList({ deviceId: devCode, schoolCode: schCode }).catch(() => ({ data: { body: [] } })),
          selectSchoolDeviceTiaotiaoProjectCodeList({ deviceId: devCode, schoolCode: schCode }).catch(() => ({ data: { body: [] } }))
        ]);
        this.allTiaotiaoCodeList = (allTiaoRes.data?.body || [])
          .filter(item => item && (item.projectCode || item.code))
          .map(item => {
            const code = String(item.projectCode || item.code || "").trim();
            return {
              ...item,
              projectCode: code,
              projectName: item.projectName || item.name || code || '未命名项目'
            };
          });
        const selectedTiaos = selectedTiaoRes.data?.body || [];
        this.selectedTiaotiaoCodes = selectedTiaos.map(i => i.projectCode).filter(Boolean);
      } catch (err) {
        console.warn("加载跳跳配置失败:", err);
      }
    },

    // 大项目多选配置
    openProjectConfigPopup() {
      if (!this.deviceData || !this.deviceData.code) return this.$toast('请先选择设备');
      this.tempProjectCodes = (this.selectedProjectCodes || []).filter(code => code && String(code).trim().toLowerCase() !== 'home');
      this.showProjectConfigPopup = true;
    },
    toggleProjectSelection(code) {
      if (!code || String(code).trim().toLowerCase() === 'home') return;
      const idx = this.tempProjectCodes.indexOf(code);
      if (idx > -1) {
        this.tempProjectCodes.splice(idx, 1);
      } else {
        this.tempProjectCodes.push(code);
      }
    },
    toggleAllProjects() {
      if (this.tempProjectCodes.length === this.allProjectCodeList.length) {
        this.tempProjectCodes = [];
      } else {
        this.tempProjectCodes = this.allProjectCodeList
          .map(i => i.projectCode || i.code)
          .filter(code => code && String(code).trim().toLowerCase() !== 'home');
      }
    },
    async saveProjectConfig() {
      const cleanCodes = (this.tempProjectCodes || []).filter(code => code && String(code).trim().toLowerCase() !== 'home');
      if (cleanCodes.length === 0) {
        return this.$toast('请至少保留一个项目');
      }
      this.savingProjectConfig = true;
      try {
        await updateDeviceProjectCode({
          deviceId: this.deviceData.code,
          schoolCode: this.teacherTitleInfo.schoolCode,
          projectCodeList: cleanCodes
        });
        this.selectedProjectCodes = [...cleanCodes];
        this.tempProjectCodes = [...cleanCodes];
        this.$toast.success('项目配置已更新');
        this.showProjectConfigPopup = false;
        // 重新拉取设备项目列表，与【切换项目】弹窗无缝联动
        await this.selectSchoolDeviceProjectCodeList();
      } catch (e) {
        this.$toast.fail('保存失败');
      } finally {
        this.savingProjectConfig = false;
      }
    },

    // 活力15动作库多选配置
    openTiaotiaoConfigPopup() {
      if (!this.deviceData || !this.deviceData.code) return this.$toast('请先选择设备');
      this.tempTiaotiaoCodes = [...this.selectedTiaotiaoCodes];
      this.showTiaotiaoConfigPopup = true;
    },
    toggleTiaotiaoSelection(code) {
      if (!code) return;
      const idx = this.tempTiaotiaoCodes.indexOf(code);
      if (idx > -1) {
        this.tempTiaotiaoCodes.splice(idx, 1);
      } else {
        this.tempTiaotiaoCodes.push(code);
      }
    },
    toggleAllTiaotiao() {
      if (this.tempTiaotiaoCodes.length === this.allTiaotiaoCodeList.length) {
        this.tempTiaotiaoCodes = [];
      } else {
        this.tempTiaotiaoCodes = this.allTiaotiaoCodeList.map(i => i.projectCode || i.code).filter(Boolean);
      }
    },
    async saveTiaotiaoConfig() {
      if (this.tempTiaotiaoCodes.length === 0) {
        return this.$toast('请至少保留一个训练动作');
      }
      this.savingTiaotiaoConfig = true;
      try {
        await updateDeviceTiaotiaoProjectCode({
          deviceId: this.deviceData.code,
          schoolCode: this.teacherTitleInfo.schoolCode,
          projectCodeList: this.tempTiaotiaoCodes
        });
        this.selectedTiaotiaoCodes = [...this.tempTiaotiaoCodes];
        this.$toast.success('活力15配置已更新');
        this.showTiaotiaoConfigPopup = false;
      } catch (e) {
        this.$toast.fail('保存失败');
      } finally {
        this.savingTiaotiaoConfig = false;
      }
    },

    // 校验时间段合法性（与后端严格对齐，提前在前端拦截异常）
    validateTimeRanges(ranges) {
      if (!ranges || ranges.length === 0) return '时间段设置为空';
      const sorted = [...ranges].sort((a, b) => (a.startTime || '').localeCompare(b.startTime || ''));
      let prevEnd = null;
      for (const item of sorted) {
        if (!item.startTime || !item.endTime) {
          return '请填写完整的开始与结束时间';
        }
        if (item.endTime <= item.startTime) {
          return '时间段错误：结束时间[' + item.endTime + ']不能早于或等于开始时间[' + item.startTime + ']';
        }
        if (prevEnd && item.startTime < prevEnd) {
          return '时间段重叠：[' + item.startTime + '-' + item.endTime + '] 与前一时段重叠';
        }
        prevEnd = item.endTime;
        if (!item.projectCode) {
          return '请为所有时间段选择执行项目';
        }
      }
      return null;
    },

    // 打开批量同步弹窗
    openSyncPopup() {
      if (!this.deviceData || !this.deviceData.code) return this.$toast('请先选择设备');
      
      const ranges = (this.timerSettings.timeRanges || []).filter(t => t.startTime || t.endTime || t.projectCode);
      if (ranges.length === 0) {
        return this.$toast('请先完善当前天的时间段和项目设置');
      }

      const checkErr = this.validateTimeRanges(ranges);
      if (checkErr) {
        return this.$toast(checkErr);
      }

      // 智能默认选中工作日
      const curWeek = String(this.submitData.week);
      if (['1', '2', '3', '4', '5'].includes(curWeek)) {
        this.selectedSyncWeeks = ['1', '2', '3', '4', '5'].filter(id => id !== curWeek);
      } else {
        this.selectedSyncWeeks = ['6', '7'].filter(id => id !== curWeek);
      }

      this.showSyncPopup = true;
    },

    // 快捷预设选择
    selectSyncPreset(type) {
      const curWeek = String(this.submitData.week);
      if (type === 'workday') {
        this.selectedSyncWeeks = ['1', '2', '3', '4', '5'].filter(id => id !== curWeek);
      } else if (type === 'all') {
        this.selectedSyncWeeks = this.availableSyncWeeks.map(w => w.id);
      } else if (type === 'clear') {
        this.selectedSyncWeeks = [];
      }
    },

    // 切换单个目标星期
    toggleSyncWeek(weekId) {
      const idx = this.selectedSyncWeeks.indexOf(weekId);
      if (idx > -1) {
        this.selectedSyncWeeks.splice(idx, 1);
      } else {
        this.selectedSyncWeeks.push(weekId);
      }
    },

    // 切换全选
    toggleAllSyncWeeks() {
      if (this.selectedSyncWeeks.length === this.availableSyncWeeks.length) {
        this.selectedSyncWeeks = [];
      } else {
        this.selectedSyncWeeks = this.availableSyncWeeks.map(w => w.id);
      }
    },

    // 确认批量同步至其他天
    confirmSyncToOtherWeeks() {
      if (this.savingSync) return;
      if (!this.deviceData || !this.deviceData.code) return this.$toast('请先选择设备');
      if (this.selectedSyncWeeks.length === 0) {
        return this.$toast('请至少选择一天进行同步');
      }

      const ranges = (this.timerSettings.timeRanges || []).filter(t => t.startTime && t.endTime && t.projectCode);
      if (ranges.length === 0) {
        return this.$toast('请完善当前天的时间段和项目设置');
      }

      const checkErr = this.validateTimeRanges(ranges);
      if (checkErr) {
        return this.$toast(checkErr);
      }

      const targetNames = this.selectedSyncWeeks
        .map(id => this.weekList.find(w => String(w.id) === String(id))?.name)
        .filter(Boolean)
        .join('、');

      Dialog.confirm({
        title: '批量同步确认',
        message: '确定将【' + this.currentWeekName + '】的 ' + ranges.length + ' 个时间段配置批量同步覆盖至【' + targetNames + '】吗？',
        confirmButtonColor: '#007AFF'
      }).then(async () => {
        this.savingSync = true;
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在批量同步...'
        });

        try {
          // 并发安全调用各天的 setWeekDeviceInfo 接口
          const requestPromises = this.selectedSyncWeeks.map(targetWeekId => {
            const weekTimeList = ranges.map(item => ({
              projectCode: item.projectCode,
              week: targetWeekId,
              startTime: item.startTime,
              endTime: item.endTime,
            }));
            return setWeekDeviceInfo({
              deviceId: this.deviceData.code,
              schoolCode: this.teacherTitleInfo.schoolCode,
              weekTimeList: weekTimeList,
            });
          });

          const responses = await Promise.all(requestPromises);

          // 响应状态兼容校验 (符合 GEMINI.md 3.3 规范)
          const allSuccess = responses.every(res => {
            const data = res?.data;
            return data && (data.status === '00' || data.status === 200 || data.status === 0 || data.code === '00' || data.code === 200 || data.code === 0 || data.success === true);
          });

          this.$toast.clear();

          if (allSuccess) {
            this.$notify({
              type: 'success',
              message: '已成功同步保存至 ' + this.selectedSyncWeeks.length + ' 个日期'
            });
            this.showSyncPopup = false;
          } else {
            this.$toast.fail('部分日期同步未成功，请检查后重试');
          }
        } catch (err) {
          this.$toast.clear();
          console.error('批量同步定时任务失败:', err);
          this.$toast.fail(err?.message || '同步失败，请稍后重试');
        } finally {
          this.savingSync = false;
        }
      }).catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
/* 弹窗多选列表与底部操作栏 */
.config-project-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  &.tiaotiao-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
.config-select-item {
  background: #f7f8fa;
  border: 1px solid #ebedf0;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s;
  .item-name {
    font-size: 13px;
    font-weight: 500;
    color: #323233;
  }
  &.active {
    background: #e8f0fe;
    border-color: #007AFF;
    .item-name {
      color: #007AFF;
      font-weight: 600;
    }
  }
  &.active-green {
    background: #e6f4ea;
    border-color: #34C759;
    .item-name {
      color: #137333;
      font-weight: 600;
    }
  }
}
.popup-bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #f2f3f5;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
}
/* --- 全局基础 --- */
.ios-glass-page {
  min-height: 100vh;
  background: radial-gradient(circle at top left, #f1f3f9, #dfe4ea);
  padding: 16px;
  padding-bottom: 40px;
  font-family: -apple-system, sans-serif;
  box-sizing: border-box;
}

.background-blobs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  
  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.6;
  }
  .blob-1 {
    width: 300px;
    height: 300px;
    background: #a0c4ff;
    top: -50px;
    left: -50px;
    animation: float 8s infinite ease-in-out;
  }
  .blob-2 {
    width: 250px;
    height: 250px;
    background: #b9fbc0;
    bottom: -50px;
    right: -50px;
    animation: float 8s infinite ease-in-out reverse;
  }
}
.section-label {
  position: relative; z-index: 1;
  font-size: 14px; font-weight: 600; color: #6e6e73;
  margin: 0 0 10px 4px;
}

/* --- 公用毛玻璃卡片 --- */
.glass-card {
  position: relative; z-index: 1;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.04);
  margin-bottom: 16px;
}

/* --- 3. 当前设备卡片 --- */
.current-device-card {
  display: flex; align-items: center; transition: transform 0.1s;
  &:active { transform: scale(0.98); background: #fff; }
  
  .device-icon-box {
    width: 44px; height: 44px; background: #d1d1d6; border-radius: 12px;
    display: flex; align-items: center; justify-content: center; margin-right: 12px;
    position: relative;
    &.online { background: #5bda7a; box-shadow: 0 4px 10px rgba(52, 199, 89, 0.3); }
    .pulse-ring {
      position: absolute; width: 100%; height: 100%; border-radius: 12px;
      border: 1px solid #34C759; opacity: 0; animation: ripple 2s infinite;
    }
  }
  .device-content {
    flex: 1;
    .device-name { font-size: 16px; font-weight: 600; color: #1c1c1e; margin-bottom: 4px; }
    .device-status {
      font-size: 12px; color: #8e8e93; display: flex; align-items: center;
      .divider { margin: 0 6px; color: #ddd; }
      .text-green { color: #34C759; }
    }
  }
  .arrow-btn { font-size: 13px; color: #007AFF; display: flex; align-items: center; }
}

/* --- 4. 详情 & 项目控制 --- */
.info-grid-card {
  padding: 0; overflow: hidden;
  .divider-line { height: 1px; background: rgba(0,0,0,0.05); margin: 0 16px; }
  .project-control-row {
    padding: 16px; display: flex; justify-content: space-between; align-items: center; background: rgba(255,255,255,0.3);
    .label { font-size: 12px; color: #8e8e93; margin-bottom: 2px; }
    .value.highlight { font-size: 16px; font-weight: 700; color: #007AFF; }
  }
}

/* --- 5. 定时设置 --- */
.week-selector {
  display: flex; justify-content: space-between; margin-bottom: 20px;
  background: rgba(142, 142, 147, 0.12); padding: 4px; border-radius: 10px;
  .week-item {
    flex: 1; text-align: center; font-size: 12px; padding: 6px 0; border-radius: 8px;
    color: #6e6e73; transition: all 0.2s;
    &.active { background: #fff; color: #007AFF; font-weight: 600; box-shadow: 0 2px 4px rgba(0,0,0,0.08); }
  }
}
.timer-item-glass {
  background: rgba(255,255,255,0.5); border-radius: 12px; padding: 12px; margin-bottom: 12px;
  border: 1px solid rgba(255,255,255,0.6);
  .timer-header {
    display: flex; justify-content: space-between; margin-bottom: 10px;
    .index-badge { font-size: 11px; color: #8e8e93; background: #f2f2f7; padding: 2px 6px; border-radius: 4px; }
  }
  .timer-inputs {
    display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;
    .input-group { 
      flex: 1; display: flex; flex-direction: column; 
      .sub-label { font-size: 10px; color: #aaa; margin-bottom: 2px; }
    }
    .separator { margin: 12px 10px 0; color: #ccc; font-size: 12px; }
  }
  .timer-project-select {
    display: flex; flex-direction: column;
    .sub-label { font-size: 10px; color: #aaa; margin-bottom: 2px; }
  }
}
.action-buttons {
  margin-top: 20px;
  .add-btn { 
    text-align: center; color: #007AFF; font-size: 14px; margin-bottom: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 4px;
  }
}

/* --- Element UI 穿透魔改 --- */
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width: 130px;
  border-radius: 8px !important;
  text-align: center;
  height: 32px;
  line-height: 32px;
  padding: 0;
}
::v-deep .glass-select .el-input__inner {
  border-radius: 8px !important;
  height: 32px;
  line-height: 32px;
}

/* --- 弹窗样式 --- */
.popup-box { background: #f9f9fb; display: flex; flex-direction: column; }
.popup-header {
  padding: 16px; background: #fff; display: flex; justify-content: space-between; align-items: center;
  .title { font-size: 16px; font-weight: 600; }
}
.popup-content { flex: 1; overflow-y: auto; padding: 16px; }

.device-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.device-item {
  background: #fff; padding: 12px; border-radius: 12px; border: 2px solid transparent; transition: all 0.2s;
  &.active { border-color: #007AFF; background: #eef7ff; }
  &.offline { opacity: 0.6; background: #f5f5f5; }
  .status-dot { width: 8px; height: 8px; border-radius: 50%; background: #ddd; margin-bottom: 8px; }
  &:not(.offline) .status-dot { background: #34C759; }
  .name { font-size: 14px; font-weight: 600; margin-bottom: 4px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;}
  .ip { font-size: 11px; color: #999; }
}

/* 项目分组 & 网格 */
.project-group {
  margin-bottom: 20px;
  .group-title {
    font-size: 14px;
    font-weight: 600;
    color: #6e6e73;
    padding: 0 16px;
    margin-bottom: 12px;
    margin-top: 16px;
  }
}
.project-grid { 
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; padding: 0 16px; 
}
.project-item {
  display: flex; flex-direction: column; align-items: center;
  .icon-box {
    width: 50px; height: 50px; border-radius: 14px; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 20px; font-weight: bold; margin-bottom: 8px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  }
  .name { font-size: 12px; color: #333; text-align: center; }
  &:active { opacity: 0.7; transform: scale(0.95); }
}

@keyframes ripple { 0% { transform: scale(1); opacity: 0.8; } 100% { transform: scale(1.4); opacity: 0; } }

.timer-btn-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .sync-btn {
    border-color: #007AFF;
    font-weight: 600;
    font-size: 14px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(8px);
    box-shadow: 0 2px 8px rgba(0, 122, 255, 0.08);
    &:active {
      background: #e8f0fe;
    }
  }
}

.sync-quick-bar {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
  .sync-quick-label {
    font-size: 12px;
    color: #6e6e73;
    font-weight: 500;
  }
  .sync-quick-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    .sync-tag {
      font-size: 11px;
      padding: 4px 10px;
      background: #f2f2f7;
      color: #007AFF;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 500;
      transition: all 0.2s;
      &:active {
        background: #e5e5ea;
        transform: scale(0.96);
      }
      &.clear-tag {
        color: #8e8e93;
      }
    }
  }
}

.sync-tip-box {
  margin-top: 14px;
  background: #f0f7ff;
  border: 1px solid #d0e4ff;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  align-items: flex-start;
  font-size: 11px;
  color: #0066cc;
  line-height: 1.5;
}
</style>